import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { Link } from 'react-router';
import Menu from 'antd/lib/menu';
import Button from 'antd/lib/button';
import { translate } from 'react-i18next';
import { MenuItemLink } from '../../../common/components';
import { ResponsiveMenu } from '../../../common/components/hoc';
import { accountRoles } from '../../../common/enums';
import moment from 'moment';

@translate()
@ResponsiveMenu('767px')
export default class MainMenu extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    menuMode: PropTypes.string.isRequired,
    accountRole: PropTypes.string.isRequired,
    registrationAction: PropTypes.string,
    accountCreated: PropTypes.objectOf(Date).isRequired,
    allowNewLoans: PropTypes.bool.isRequired,
  };

  render() {
    const { t, accountRole, menuMode, accountCreated, allowNewLoans, registrationAction } = this.props;
    const disableNewLoan = !allowNewLoans || registrationAction;

    return (
      <Row center="xs" end="sm" className="dashboard-menu-wrapper">
        <Col xs={12} sm={9} md={10} className="dashboard-menu">
          <Menu mode={menuMode}>
            {accountRole === accountRoles.DEBTOR && (
              <MenuItemLink to="/dashboard/loans">{t('Moje pôžičky')}</MenuItemLink>
            )}
            {accountRole === accountRoles.CREDITOR && (
              <MenuItemLink to="/dashboard/overview">{t('Prehľad účtu')}</MenuItemLink>
            )}
            {accountRole === accountRoles.CREDITOR && (
              <MenuItemLink to="/dashboard/investments">{t('Moje investície')}</MenuItemLink>
            )}
            {accountRole === accountRoles.CREDITOR && (
              moment(accountCreated).isAfter(moment(new Date("2021-06-28"))) ?
              <MenuItemLink to="/dashboard/transactions">{t('Transakcie a exporty')}</MenuItemLink>
              : 
              <MenuItemLink to="/dashboard/exportInvestorPayments">{t('Transakcie a exporty')}</MenuItemLink>
            )}
            {accountRole === accountRoles.EXECUTOR && (
              <MenuItemLink to="/dashboard/disposals">{t('Moje pohľadávky')}</MenuItemLink>
            )}
            {(accountRole !== accountRoles.EXECUTOR) && (
              <MenuItemLink to="/dashboard/documents">{t('Dokumenty')}</MenuItemLink>
            )}
            <MenuItemLink to="/dashboard/personal-info">{t('Osobné údaje')}</MenuItemLink>
            {/* Mobile devices, PIN change and password live on the settings
                page; without a main-menu entry debtors looked for them under
                "Osobné údaje" and did not find them (client feedback 09-2026). */}
            <MenuItemLink to="/dashboard/settings">{t('Nastavenia')}</MenuItemLink>

            {/* {(accountRole === accountRoles.CREDITOR || accountRole === accountRoles.EXECUTOR) && (
              <MenuItemLink to="/dashboard/withdraw-funds">{t('Platby')}</MenuItemLink>
            )} */}
            {/* {accountRole === accountRoles.CREDITOR && (
              <MenuItemLink to="/dashboard/exportInvestorPayments">{t('Exporty')}</MenuItemLink>
            )} */}
            {/* {(accountRole === accountRoles.CREDITOR || accountRole === accountRoles.DEBTOR) && (
              <MenuItemLink to="/dashboard/transactions">{t('Prehľad transakcií')}</MenuItemLink>
            )} */}
          </Menu>
        </Col>
        <Col xs={12} sm={3} md={2} className="dashboard-menu-action">
          {accountRole === accountRoles.DEBTOR && (
            <React.Fragment>
              <Link to="dashboard/create-loan">
                <Button
                  type="primary"
                  size="default"
                  className="btn-block"
                  disabled={disableNewLoan}
                >{t('Nová žiadosť')}</Button>
              </Link>
            </React.Fragment>
          )}
          {accountRole === accountRoles.CREDITOR && (
            <Link to="dashboard/create-investment">
              <Button type="primary" size="default" className="btn-block">
                {t('Nová investícia')}
              </Button>
            </Link>
          )}
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/components/MainMenu.js